//import loader_img1 from './thinking_dribbble.gif';
//import loader_img2 from './alcohol-drink.gif'; 

export function getAccount() {
	const params = new URLSearchParams(window.location.search);
	var domain = params.get('domain');
	if (domain != null)
		return domain;
	return sessionStorage.getItem('domain');
}

export function getConfig() {
	try {
		const config = sessionStorage.getItem('config');
		if (config != null && config != "undefined")
			return JSON.parse(config);
		return {};
	} catch (e) {
		return {};
	}
}

export function setConfig(cfg) {
	return sessionStorage.setItem('config', JSON.stringify(cfg));
}

export function getDomain() {
	return sessionStorage.getItem('domain')
}

export function getUser() {
 	return sessionStorage.getItem('user')
}

export function getClientId() {
 	return sessionStorage.getItem('clientId')
}

export function getMemoryObj() {
	try {
		const memo = sessionStorage.getItem('memory');
		if (memo != null && memo != "undefined")
			return JSON.parse(memo);
		return {};
	} catch (e) {
		return {};
	}
}

//const DATA = getAccount() == undefined ? "NONE" : getAccount().toUpperCase();
